import React from 'react';
import { EmiFeeActions, IFeeWaiveInfoText } from './interfaces';
import cx from 'classnames';
import { Typography } from '@navi/web-ui/lib/primitives';
import { formatAmount } from '@cp/src/utils/commonUtils';

const FeeWaiveInfoText: React.FC<IFeeWaiveInfoText> = ({ emiData }) => {
  const {
    isMaxWaived,
    action,
    additionalWaiverInfo,
    unpaidDueAmount,
    waivedAmount,
    waiverOrHoldAmount
  } = emiData || {};
  const { maxWaivableAmount, refundedAmount, maxRefundableAmount } = additionalWaiverInfo || {};
  const textColor = isMaxWaived ? 'text-[var(--green-light-1)]' : 'text-[var(--blue-light)]';
  const boldTextClasses = cx('font-bold', textColor);
  if (isMaxWaived) {
    if (refundedAmount > 0) {
      return (
        <>
          Max waive of{' '}
          <Typography variant="p5" as="span" className={boldTextClasses}>
            {formatAmount((waivedAmount || 0) + refundedAmount)}
          </Typography>{' '}
          is applied.{' '}
          {waivedAmount > 0 ? (
            <>
              <Typography variant="p5" as="span" className={boldTextClasses}>
                {formatAmount(waivedAmount)}
              </Typography>{' '}
              is waived instantly,{' '}
            </>
          ) : (
            ''
          )}
          <Typography variant="p5" as="span" className={boldTextClasses}>
            {formatAmount(refundedAmount)}
          </Typography>{' '}
          will be refunded.
        </>
      );
    }
    return (
      <>
        Max {waivedAmount > 0 ? 'waive' : 'hold'} of{' '}
        <Typography variant="p5" as="span" className={boldTextClasses}>
          {formatAmount(waiverOrHoldAmount)}
        </Typography>{' '}
        is applied
      </>
    );
  }
  if (action === EmiFeeActions.ADJUST) {
    return (
      <>
        You can waive / hold {waiverOrHoldAmount <= 0 ? 'maximum of ' : null}
        <Typography variant="p5" as="span" className={boldTextClasses}>
          {formatAmount(maxWaivableAmount)}
        </Typography>{' '}
        {waiverOrHoldAmount > 0 ? 'more ' : ''}
        from penalty
        <Typography variant="p5" className={cx(textColor, 'ml-2')}>
          &#x2022; Amount less than{' '}
          <Typography variant="p5" as="span" className={boldTextClasses}>
            {formatAmount(unpaidDueAmount)}
          </Typography>{' '}
          will be held
        </Typography>
        <Typography variant="p5" className={cx(textColor, 'ml-2')}>
          &#x2022; Amount{maxWaivableAmount === unpaidDueAmount ? '' : ' greater than or'} equal to{' '}
          <Typography variant="p5" as="span" className={boldTextClasses}>
            {formatAmount(unpaidDueAmount)}
          </Typography>{' '}
          will be instantly waived
        </Typography>
      </>
    );
  }
  return (
    <>
      You can {action === EmiFeeActions.WAIVE ? 'waive' : 'hold'}{' '}
      {waiverOrHoldAmount <= 0 ? 'maximum of ' : null}
      <Typography variant="p4" as="span" className={boldTextClasses}>
        {formatAmount(maxWaivableAmount)}
      </Typography>{' '}
      {waiverOrHoldAmount > 0 ? 'more ' : ''}
      from penalty charges. {maxRefundableAmount ? 'Amount will be refunded to the customer.' : ''}
    </>
  );
};

export default FeeWaiveInfoText;
